interface VacancyData {
  title: string;
  url: string;
  post: number;
  text: string[];
  tags: string[];

}

type VacancyJsonFile = {
  title: string;
  url: string;
  post: number;
  text: string[];
  tags: string[];

};

type WebpackContext = {
  (key: string): VacancyJsonFile;
  keys: () => string[];
};

export function getVacancyData(locale: string): VacancyData[] {
  let VacancyContext: WebpackContext;

  switch (locale) {
    case 'nl':
      VacancyContext = require.context(
        "../../public/locales/nl/vacancies",
        true,
        /\.json$/
      );
      break;
    case 'gb':
      VacancyContext = require.context(
        "../../public/locales/gb/vacancies",
        true,
        /\.json$/
      );
      break;
    // ... Handle other locales
    default:
      VacancyContext = require.context(
        "../../public/locales/nl/vacancies",
        true,
        /\.json$/
      ); // default to nl if no match
      break;
  }

  const VacancyData: VacancyData[] = [];
  VacancyContext.keys().forEach((fileName: string) => {

    try {
      const vacancyJson = VacancyContext(fileName);
      const title = vacancyJson.title;
      const url = vacancyJson.url;
      const post = vacancyJson.post;
      const text = vacancyJson.text;
      // const tags = VacancyJson.tags;

      VacancyData.push({
        title,
        url,
        post,
        text,
        tags: vacancyJson.tags || [] // default to an empty array if no tags are present
      });
    } catch (error) {
      console.error(`Error parsing ${fileName}:`, error);
   }


  });

  return VacancyData;
}
